<template>
    <el-scrollbar class="exam-result">
        <div class="exam-result-box">
            <div class="exam-result-box_header">
                <div class="header-label">考试成绩</div>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>

            <el-table
                :data="tableData"
                style="
                    width: 100%;
                    flex: 1;
                    border: 1px solid #f2f4f7;
                    border-radius: 4px;
                "
                size="medium"
                :header-cell-style="{
                    fontWeight: 'normal',
                    color: '#333',
                    background: '#f5f7fa',
                }"
                class="table-content"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column label="学号" prop="s_account"> </el-table-column>
                <el-table-column label="姓名" prop="s_name"> </el-table-column>
                <el-table-column label="性别" :align="'center'">
                    <template slot-scope="scope">
                        {{ scope.row.sex || "-" }}
                    </template>
                </el-table-column>
                <el-table-column label="成绩" width="80" :align="'center'">
                    <template slot-scope="scope">
                        {{ !isNaN(scope.row.score) ? scope.row.score.toFixed(2) : "-" }}
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    :current-page="pageParams.page"
                    :page-size="pageParams.limit"
                    @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="pageParams.total"
                >
                </el-pagination>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    name: "ExamResult",
    data() {
        return {
            pageParams: {
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],
        };
    },
    created() {
        this.getExamData();
    },
    methods: {
        getExamData() {
            // evaluation_exam_list
            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                page: this.pageParams.page,
                limit: this.pageParams.limit,
            };

            this.$shttp.axiosGetBy(
                this.$api.evaluation_exam_list,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.tableData = res.data.list || [];

                        this.pageParams.total = res.data.total;
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;
            this.getExamData();
        },
    },
};
</script>

<style lang="scss" scoped>
.exam-result {
    height: 100%;
    height: calc(100vh - 70px);
    box-sizing: border-box;
    padding: 20px;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .exam-result-box {
        background-color: #ffffff;
        padding: 24px 40px;
        border-radius: 4px;
        box-sizing: border-box;
        min-height: calc(100vh - 110px);

        &_header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 24px;
            margin-bottom: 30px;

            .header-label {
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 800;
                font-size: 24px;
                color: #333333;
            }

            .el-button {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 88px;
                height: 36px;
            }
        }

        .pagination {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
        }
    }
}
</style>
